/* eslint-disable no-unused-vars */
import numbersHelper from '@/core/mixins/numbersHelper';
import {
  format,
  parseISO,
  isValid,
  isPast,
} from 'date-fns';

export default {
  mixins: [
    numbersHelper,
  ],
  methods: {
    isDateInThePast(dateString) {
      return dateString && isPast(Date.parse(dateString));
    },
    formatDate(date, formats) {
      if (!isValid(new Date(date))) return '';
      if (typeof date !== 'string') return format(parseISO(this.convertDateToString(date)), formats);
      return format(parseISO(date), formats);
    },
    formatDateForEoC(date) {
      return this.formatDate(date, 'dd/MM/yyyy');
    },
    formatDateForPlatform(date) {
      return this.formatDate(date, 'dd/MM/yyyy');
    },
    parseISOString(s) {
      const d = s.split(/\D+/);
      const date = new Date(Date.UTC(d[0], --d[1], d[2]));
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
      return date;
    },
    convertDateFormat(timestamp) {
      if (!timestamp) {
        return null;
      }
      const currentDate = new Date(timestamp * 1000);
      const date = currentDate.getDate();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      return [date, month, year];
    },
    convertDateToString(date) {
      if (!date || !isValid(new Date(date))) return null;
      const adjustedDate = new Date(date);
      return `${adjustedDate.getFullYear()}-${this.convertNumberToString(adjustedDate.getMonth() + 1)}-${this.convertNumberToString(adjustedDate.getDate())}`;
    },
  },
};
